import React from 'react';

export default function SalesGroupTable({ salesGroups, onGroupUpdateOrDelete }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="sales-group-table" className="table">
				<thead>
					<tr>
						<th>Name</th>
						<th>Obsolete</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{salesGroups
						? salesGroups.map(group => (
								<tr key={group.id}>
									<td>{group.groupName}</td>
									<td>
										<div className="checkbox">
											<input
												disabled
												type="checkbox"
												checked={group.obsolete === '1' ? 'checked' : ''}
											/>
										</div>
									</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onGroupUpdateOrDelete(group)}
										/>
										<i
											data-toggle="modal"
											data-target="#oneInputEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onGroupUpdateOrDelete(group)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
